export const planCardSectionConfig = {
    name: 'PlanCardSection',
    category: 'Zapier Sections',
    includeScrollTracking: true,
    image: 'https://cdn.zappy.app/c472db9691b4395e01a6c517aef6e361.png',
    inputs: [
        {
            name: 'plans',
            type: 'list',
            subFields: [
                {
                    name: 'title',
                    type: 'string',
                    defaultValue: 'Free',
                },
                {
                    name: 'description',
                    type: 'longText',
                    defaultValue: 'For individuals who need the basics of automation',
                },
                {
                    name: 'primaryCTA',
                    type: 'object',
                    subFields: [
                        { name: 'href', type: 'string' },
                        { name: 'text', type: 'string' },
                        {
                            name: 'color',
                            type: 'string',
                            enum: ['primary', 'primary-alt', 'secondary'],
                        },
                    ],
                    defaultValue: {
                        href: 'zapier.com',
                        text: 'Try free',
                    },
                },
                {
                    name: 'secondaryCTA',
                    type: 'object',
                    subFields: [
                        {
                            name: 'text',
                            type: 'string',
                        },
                        {
                            name: 'href',
                            type: 'string',
                        },
                    ],
                },
                {
                    name: 'content',
                    type: 'uiBlocks',
                    hideFromUI: true,
                    defaultValue: [],
                },
                {
                    name: 'featuresText',
                    type: 'string',
                    defaultValue: 'Free plan features:',
                },
                {
                    name: 'features',
                    type: 'list',
                    subFields: [
                        { name: 'href', type: 'string' },
                        { name: 'text', type: 'string' },
                        { name: 'tooltip', type: 'longText' },
                    ],
                    defaultValue: [
                        {
                            text: 'Single-step Zaps',
                            tooltip: 'Single step Zaps',
                        },
                        {
                            text: 'Single-step Zaps',
                            tooltip: 'Single step Zaps',
                        },
                    ],
                },
            ],
            defaultValue: [
                {
                    title: 'Free',
                    description: 'For individuals who need the basics of automation',
                    content: [],
                    primaryCTA: {
                        href: 'zapier.com',
                        text: 'Try free',
                        color: 'primary',
                    },
                    secondaryCTA: {
                        href: 'zapier.com',
                        text: 'Secondary CTA',
                    },
                    featuresText: 'Free plan features:',
                    features: [
                        {
                            text: 'Single-step Zaps',
                            tooltip: 'Single step Zaps',
                        },
                    ],
                },
            ],
        },
    ],
};
//# sourceMappingURL=config.js.map